import React from 'react';
import { Box, Text } from '@common-fe/common-fe';

import { ROUTES } from '@/common';
import Link from '@/modules/core/components/Link';

import EmployerSectionPlaceholder from '../EmployerSectionPlaceholder';

import ClaimTypeDonut from './components/ClaimTypeDonut';
import ServiceCategoriesDonut from './components/ServiceCategoriesDonut';
import { useGetCurrentEmployerId } from './hooks';
import { useGetClaimDetailsQuery } from './queries';
import ServiceCategoriesChart from './ServiceCategoriesChart';

interface Props {
  isLoading?: boolean;
  planId: string;
}

const EmployerServiceCategoriesContainer: React.FC<Props> = ({ isLoading, planId }) => {
  const { isLoading: queryIsLoading, isError, refetch, claimDetails } = useGetClaimDetailsQuery(planId);

  const employerId = useGetCurrentEmployerId();

  if (isLoading || queryIsLoading) {
    return (
      <Box
        background="canvas"
        pad="spacing24"
        direction="row"
        round="container2Round"
        height="256px"
        border={{ size: '1px', color: 'border2' }}
        data-testid="employer-service-categories_loading"
      >
        <ServiceCategoriesChart title="Service categories" />
        <Box height={{ min: '100%' }} width="2px" background="border2" margin={{ horizontal: 'spacing12' }} />
        <ServiceCategoriesChart title="Claim type" />
      </Box>
    );
  }

  if (isError) {
    return (
      <EmployerSectionPlaceholder onTryAgain={refetch}>
        We couldn't load your spend data
      </EmployerSectionPlaceholder>
    );
  }

  return (
    <Box
      background="canvas"
      pad="spacing24"
      direction="row"
      round="container2Round"
      border={{ size: '1px', color: 'border2' }}
      data-testid="employer-service-categories"
    >
      <ServiceCategoriesDonut
        categories={claimDetails.categories}
        totalPaidClaims={claimDetails.total}
        titleNode={
          <Link to={`${ROUTES.CLAIMS_ACTIVITY_REPORT}?employerId=${employerId}`} isOpenNewTab>
            <Text size="medium" color="textAccent" weight={400} style={{ lineHeight: '20px' }}>
              Claim Activity Report
            </Text>
          </Link>
        }
      />
      <Box height={{ min: '100%' }} width="2px" background="border2" margin={{ horizontal: 'spacing12' }} />
      <ClaimTypeDonut paymentMethods={claimDetails.paymentMethods} totalPaidClaims={claimDetails.total} />
    </Box>
  );
};

export default EmployerServiceCategoriesContainer;
